/**
 * Масштабирование маски аватара из холста 0–100 в пиксели.
 *
 * <p>Формы из {@link ../avatar/shapeCatalog} нарисованы в системе координат 0–100 и в SVG
 * растягиваются одним `viewBox`. Вне SVG такого удобства нет: CSS-свойство `clip-path: path()`
 * читает путь в пикселях элемента, поэтому для живой (анимированной) аватарки в вебе путь
 * приходится пересчитывать самому.
 *
 * <p><b>Про «просто умножить все числа».</b> Так можно не для любого пути: у дуги (`A`) два
 * средних параметра — флаги, и умножать их нельзя. В каталоге форм дуг нет (только `M`, `L`,
 * `Q`, `C`, `Z`), поэтому здесь честнее отказаться, чем молча испортить маску: путь с `A`
 * возвращается как есть, и вызывающий рисует без обрезки, а не кривую кляксу.
 */

/** Есть ли в пути команды, для которых умножение всех чисел неверно. */
function hasUnsupportedCommand(d: string): boolean {
  return /[aA]/.test(d);
}

/** Умножает все координаты пути на `scale`, округляя до сотых. */
export function scaleShapePath(d: string, scale: number): string | null {
  if (!d || !Number.isFinite(scale) || scale <= 0) return null;
  if (hasUnsupportedCommand(d)) return null;
  return d.replace(/-?\d+(?:\.\d+)?/g, (num) => {
    const scaled = Number(num) * scale;
    return String(Math.round(scaled * 100) / 100);
  });
}
